<template>
  <v-dialog v-model="isShow" persistent width="400px" class="add-edit-wrapper">
    <v-card class="card" style="width: 400px">
      <!--TITLE-->
      <v-card-title class="bg-grey fs-1-5r mb-4">
        {{ type === 'add' ? $t('Add Group') : $t('Edit Group') }}
      </v-card-title>

      <v-card-text class="my-2">
        <v-text-field
          v-model="localGroup.name"
          :label="$t('Name')"
          outlined
          dense
          :class="[type === 'add' && 'required']"
        ></v-text-field>

        <div class="d-flex mb-3">
          <!--INPUT FOR USERS EMAIL AND NAME-->
          <v-autocomplete
            v-model="localGroup.casualUsers"
            :items="casualUsers"
            :menu-props="customeMenuProps"
            multiple
            placeholder="Select"
            return-object
            hide-details
            item-text="email"
          >
            <template v-slot:selection="{ item }">
              <span class="pill">
                {{ item.name }}
              </span>
            </template>

            <template v-slot:item="{ item, attrs }">
              <v-list-item-avatar>
                <v-simple-checkbox
                  :value="attrs.inputValue"
                  hide-details
                  class="ma-0 pa-0"
                  color="primary"
                >
                </v-simple-checkbox>
              </v-list-item-avatar>
              <v-list-item-content class="dir-ltr">
                <div class="div-click-fixer"></div>
                <div class="div-click-fixer-left"></div>
                <v-list-item-title v-html="item.email"></v-list-item-title>
                <v-list-item-subtitle v-html="item.name"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between">
        <div class="d-flex">
          <div
            @mouseover="showMessage = true"
            @mouseleave="showMessage = false"
          >
            <Button
              class="mx-1"
              :text="parent === 'user' ? $t('Save') : 'Proceed'"
              :clickAction="saveGroup"
              :disabled="!!errMsg"
            />
          </div>

          <transition name="slide-fade">
            <span class="mr-8 red--text message fs-1r" v-if="showMessage">{{
              errMsg
            }}</span>
          </transition>
        </div>
        <Button
          :text="$t('Cancel')"
          :clickAction="closeDialog"
          btnType="grey"
          class="mx-1"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'

export default {
  data() {
    return {
      type: '',
      errMsg: null,
      showMessage: false,
      localGroup: { name: '', casualUsers: [] },
    }
  },
  props: {
    closeDialog: Function,
    casualGroupAddEdit: Object,
    casualUsers: Array,
    casualGroups: Array,
    saveCasualGroupPopUp: Function,
    deleteGroupClicked: Function,
    parent: String,
  },

  watch: {
    localGroup: {
      handler() {
        this.checkSettings()
      },
      deep: true,
      immediate: true,
    },
    'localGroup.name': {
      handler: function (n) {
        if (n.includes(' ')) {
          this.localGroup.name = this.localGroup.name.replaceAll(' ', '-')
        }
      },
    },
  },
  components: {
    Button,
  },

  computed: {
    customeMenuProps() {
      const { height } = this.$vuetify.breakpoint
      if (height <= 750) return {}
      else if (height > 750 && height < 900) return { maxHeight: '400px' }
      return { maxHeight: '500px' }
    },
    isShow() {
      return !!this.casualGroupAddEdit
    },
  },

  methods: {
    checkSettings() {
      if (!this.localGroup.name)
        return (this.errMsg = this.$t('Name is required'))
if (this.localGroup.name.length > 50)
        return (this.errMsg = this.$t('Name is too long'))
      if (
        this.type === 'add' &&
        this.casualGroups.some(el => el.name === this.localGroup.name.trim())
      )
        return (this.errMsg = this.$t('Name is taken'))
      this.errMsg = null
    },
    saveGroup() {
      this.casualGroupAddEdit.name = this.localGroup.name
      this.casualGroupAddEdit.casualUsers = this.localGroup.casualUsers
      this.saveCasualGroupPopUp()
    },
  },

  created() {
    if (this.casualGroupAddEdit.name) {
      this.type = 'edit'
      this.localGroup = JSON.parse(JSON.stringify(this.casualGroupAddEdit))
    } else this.type = 'add'
    console.log(this.casualGroupAddEdit)
  },
}
</script>

<style scoped lang="scss">
.add-edit-wrapper {
  position: fixed;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12;
}
.pill {
  background-color: #e3e3e3;
  padding: 2px 5px;
  border-radius: 10px;
  margin: 2px 4px;
}
</style>
